<template>
    <div class="backgroud-white cs-courseSchedule-editor">
        <div class="backgroud-gray-popup popup-content-area-small" ref="listForm">
            <el-row v-for="(item,index) in universityDataList" :key="index">
                <university-info-editor :rowIndex="index" :universityInfo="item" v-on:deleteRow="onDeleteRow" v-on:addRow="onAddRow" :universityList="universityDataList" ref="universityInfoEditor" :isLastRow="index==universityDataList.length-1"></university-info-editor>
            </el-row>
        </div>
        <div slot="footer" class="dialog-footer popup-footer">
            <el-row>
                <el-col :span="16" class="footer-left">
                    <span v-if="!showError"></span>
                    <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                </el-col>
                <el-col class="footer-right" :span="8">
                    <el-button :type="submitBtnClass" @click="save()">保存</el-button>
                    <el-button type="info" @click="cancel()">取消</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import universityInfoEditor from "./universityInfoEditor";
import { saveUniversityGroups } from "../service/common.service";
import { guid } from "../config/mUtils";
export default {
  props: ["universityList", "universityGroup"],
  data() {
    return {
      showError: false,
      errorMessage: "",
      submitBtnClass: "primary",
      universityDataList: [],
      removeIdList: []
    };
  },
  created() {
    this.loadUniversityList();
  },
  components: {
    universityInfoEditor
  },
  methods: {
    loadUniversityList() {
      this.universityDataList = [];
      if (this.universityList && this.universityList.length > 0) {
        this.universityList.forEach(item => {
          let university = {
            id: guid(),
            dataId: item.Id,
            name: item.Name,
            abbreviation: item.Abbreviation,
            hasSaturdayCourse: item.HasSaturdayCourse,
            hasSundayCourse: item.HasSundayCourse,
            groupNumber: item.GroupNumber
          };
          this.universityDataList.push(university);
        });
      } else {
        this.onAddRow();
      }
    },
    async save() {
      let valid = true;
      this.$refs.universityInfoEditor.forEach(editor => {
        valid = valid && editor.validateRow();
      });
      if (!valid) return;
      let removingUniversities = [];
      if (this.removeIdList.length > 0) {
        this.universityList.forEach(item => {
          if (this.removeIdList.indexOf(item.Id) >= 0) {
            removingUniversities.push(item.Abbreviation);
          }
        });
      }
      let isConfirmed = true;
      if (removingUniversities.length > 0) {
        await this.$confirm(
          "您确定将以下大学将从该分组中删除吗？大学：" +
            removingUniversities.join(","),
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            isConfirmed = true;
          })
          .catch(() => {
            isConfirmed = false;
          });
      }
      if (isConfirmed) {
        saveUniversityGroups(this.universityDataList, this.removeIdList).then(
          result => {
            if (!!result && result.success) {
              if (result.data.indexOf("保存成功") >= 0) {
                this.$message({
                  message: result.data,
                  type: "success"
                });
                this.$emit("saveSuccess");
              } else {
                this.$message({
                  message: result.data,
                  type: "warning"
                });
              }
            } else {
              this.$message.error(result.message);
            }
          }
        );
      }
    },
    cancel() {
      this.$emit("closeUniversityGroupEditor");
    },
    onAddRow() {
      let university = {
        id: guid(),
        dataId: 0,
        name: "",
        abbreviation: "",
        hasSaturdayCourse: false,
        hasSundayCourse: false,
        groupNumber: this.universityGroup
      };
      this.universityDataList.push(university);
    },
    onDeleteRow(universityId) {
      this.universityDataList.forEach((item, i) => {
        if (item.id === universityId) {
          if (item.dataId && this.removeIdList.indexOf(item.dataId) < 0) {
            this.removeIdList.push(item.dataId);
          }
          this.universityDataList.splice(i, 1);
        }
      });
    },
    reset(){ 
        this.universityDataList=[];
        this.removeIdList=[]; 
    }
  },
  watch: {
    universityList: function() {
      this.loadUniversityList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/universityGroupEditor.vue